var copy = function copy() {
  var button = document.querySelector('.js-copy');
  var CLASS = 'is-done';
  var TIMER = 2000;
  button.addEventListener('click', function () {
    var url = button.getAttribute('data-url');
    navigator.clipboard.writeText(url);
    button.classList.add(CLASS);
    setTimeout(function () {
      button.classList.remove(CLASS);
    }, TIMER);
  }, false);
};
export default copy;